import { Trans as ReactI18nextTrans, useTranslation } from "react-i18next";

const Trans: typeof ReactI18nextTrans = function Trans(props: any) {
  // This hook is used to force re-rendering of the component when the language changes.
  useTranslation();
  return <ReactI18nextTrans {...props} />;
} as any;

export { Trans };
